import { api } from '@cwd/lib/main';
import type { DomainValidationListItem, DomainValidationUsage } from './DeliverabilityTypes';

export interface DomainValidationListResult {
    Results: DomainValidationListItem[];
    Count: number;
}

export async function getDomainValidations(
    skip: number = 0,
    top: number = 50,
    filter?: string,
    orderBy: string = 'Domain asc'
): Promise<DomainValidationListResult> {
    let url = `/BackOffice/Account/DomainValidation?$inlinecount=allpages&$top=${top}&$skip=${skip}&$orderby=${encodeURIComponent(orderBy)}`;
    if (filter) {
        url += `&$filter=${encodeURIComponent(filter)}`;
    }
    return api.get(url);
}

export async function getDomainUsage(domain: string): Promise<DomainValidationUsage> {
    return api.get(`/BackOffice/Account/DomainValidation/Usage?domain=${encodeURIComponent(domain)}`);
}

export async function validateEmailDomain(email: string): Promise<DomainValidationListItem> {
    return api.get(`/BackOffice/Account/DomainValidation/Single?email=${encodeURIComponent(email)}`);
}

export async function fixEmailDomain(accountId: string): Promise<boolean> {
    return api.post(`/BackOffice/Account/${encodeURIComponent(accountId)}/FixAccountEmailDomain`);
}

export async function deleteDomainValidation(domain: string): Promise<void> {
    return api.delete(`/BackOffice/Account/DomainValidation?domain=${encodeURIComponent(domain)}`);
}
